module.exports = __webpack_public_path__ + "assets/0ebb4afda6c124f5847e932b862689f2.mp3";